<template>
    <div id="pageUser">
        <v-container grid-list-xl fluid class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa fa-user</v-icon>
                                Lista de Usuarios
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="usuarioEstado"
                                    label="Usuarios"
                                    :items="[
                                        { text: 'Todos', value: '1' },
                                        { text: 'Habilitados', value: '2' },
                                        { text: 'Inactivos', value: '3' },
                                        { text: 'Eliminados', value: '4' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadEmpleado()"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0 ">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                    >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn icon @click="toogleSearch()">
                                    <v-icon medium>fa fa-search</v-icon>
                                </v-btn>

                                <v-expand-x-transition>
                                    <v-text-field
                                        hide-details
                                        solo
                                        v-show="searchShow"
                                        v-model="filter.search"
                                        placeholder="Filtrar"
                                        class="hidden-sm-and-down pt-2"
                                    >
                                    </v-text-field>
                                </v-expand-x-transition>

                                <v-divider class="pa-2"></v-divider>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat @click="openForm(null)">
                                            <v-icon medium v-on="on">fa fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Agregar Usuario</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="USERS"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr :class="isCurrentUser(props.item) ? 'success--text' : ''">
                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon
                                                        size="22px"
                                                        color="black"
                                                        v-if="isCurrentUser(props.item)"
                                                        v-on="on"
                                                        >fa-user</v-icon
                                                    >
                                                </template>
                                                <span>Usuario autenticado</span>
                                            </v-tooltip>
                                            {{ props.item.username }}
                                        </td>
                                        <td>{{ props.item.first_name + " " + props.item.last_name }}</td>
                                        <td>{{ props.item.email }}</td>
                                        <td>{{ getUserTableRoles(props.item) }}</td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                :color="getChipColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{ getEstadoDescription(props.item) }}
                                            </v-chip>
                                            <div class="action-column">
                                                <template v-if="props.item.status !== 0">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                color="grey"
                                                                :disabled="loading"
                                                                @click="openDetails(props.item)"
                                                            >
                                                                <v-icon medium v-on="on">fa-eye</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Ver detalles</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                color="orange"
                                                                :disabled="
                                                                        loading ||
                                                                            isSuperadmin(props.item) ||
                                                                            isCurrentUser(props.item) ||
                                                                            menuLocked
                                                                    "
                                                                @click="openForm(props.item)"
                                                            >
                                                                <v-icon medium v-on="on">fa fa-edit </v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Editar Usuario</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                color="red"
                                                                :disabled="
                                                                        loading ||
                                                                            isSuperadmin(props.item) ||
                                                                            isCurrentUser(props.item) ||
                                                                            menuLocked
                                                                    "
                                                                :loading="loadingDelete"
                                                                @click="deleteItem(props)"
                                                            >
                                                                <v-icon medium v-on="on">fa-trash </v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Eliminar Usuario</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-switch
                                                                v-model="props.item.statusEnabled"
                                                                class="shrink ml-2"
                                                                v-on="on"
                                                                :disabled="
                                                                        loading ||
                                                                            isSuperadmin(props.item) ||
                                                                            isCurrentUser(props.item) ||
                                                                            menuLocked
                                                                    "
                                                                color="success"
                                                                height="45px"
                                                                hide-details
                                                                :loading="loadingToogleStatus"
                                                                @change="toogleUserStatus(props.item)"
                                                            >
                                                            </v-switch>
                                                        </template>
                                                        <span>{{
                                                                props.item.statusEnabled === true
                                                                    ? "Deshabilitar Usuario"
                                                                    : "Habilitar Usuario"
                                                            }}</span>
                                                    </v-tooltip>
                                                </template>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="py-0 pl-0 text-xs-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                        <v-icon v-on="on">fa-close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cancelar acción</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="green" @click="deleteItemConfirm(props)">
                                                        <v-icon v-on="on">fa-check</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Confirmar acción</span>
                                            </v-tooltip>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen usuarios registrados en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <user-form v-if="showForm" :form-title="title" :initial-item="editItem" @formCanceled="closeForm"> </user-form>

        <user-details v-if="showDetails" :details-item="detailsItem" @detailsCanceled="closeDetails"> </user-details>
    </div>
</template>

<script>
import _ from "lodash"
import { mapGetters } from "vuex"
const UserForm = () => import("@/components/user-form/user-form")
const UserDetails = () => import("@/components/user-details/user-details")

export default {
    components: {
        UserDetails,
        UserForm
    },
    props: {
        //estado de los usuarios a cargar del back
        estado: { type: String, default: null }
    },
    data: () => ({
        searchShow: false,

        loading: false,
        loadingDelete: false,
        loadingToogleStatus: false,

        title: "",
        showForm: false,
        showDetails: false,
        headers: [
            { text: "Usuario", value: "username" },
            { text: "Nombre y apellidos", value: "last_name", sortable: false },
            { text: "Correo electrónico", value: "email" },
            { text: "Roles", sortable: false },
            { text: "Estado", value: "status" }
        ],
        editItem: null,
        detailsItem: null,
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteUserConfirmId: "",

        menuLocked: false,

        //estado de los usuarios a cargar del back
        usuarioEstado: "2",

        //para saber si ya se aplico el valor obtenido por las props
        estadoApplied: false
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado) {
            this.loading = true
            this.$store
                .dispatch("LOAD_USERS", {
                    filter: this.filter.search,
                    usuarioEstado: estado
                })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },
        openForm(item) {
            if (item !== null) {
                this.title = "Modificar usuario"
                this.editItem = item
            } else {
                this.title = "Nuevo usuario"
            }
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        closeDetails() {
            this.showDetails = false
            this.detailsItem = null
        },

        openDetails(item) {
            this.detailsItem = item
            this.showDetails = true
        },

        deleteItem(props) {
            this.menuLocked = true
            this.deleteUserConfirmId = props.item.id
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteUserConfirmId === props.item.id) {
                this.loadingDelete = true
                this.$store.dispatch("DELETE_USER", props.item).then(() => {
                    this.loadingDelete = false
                    this.menuLocked = false
                    this.deleteUserConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteUserConfirmId = ""
            props.expanded = !props.expanded
        },

        toogleUserStatus(item) {
            this.loadingToogleStatus = true
            this.$store.dispatch("TOOGLE_USER_STATUS", item).then(() => {
                this.loadingToogleStatus = false
            })
        },

        loadEmpleado() {
            this.loadData(this.usuarioEstado)
        },

        searchData: _.debounce(function() {
            this.loadData(this.usuarioEstado)
        }, 1000),

        getUserTableRoles(item) {
            if (item.status === 0) {
                return "Eliminado"
            } else if (item.roles) {
                let ret_roles = ""
                item.roles.forEach(rol => {
                    ret_roles = ret_roles + rol.name + ", "
                })
                return ret_roles.slice(0, -2)
            } else return "-"
        },

        isSuperadmin(item) {
            if (item.roles) {
                return item.roles.some(el => el.name === "superadmin")
            } else return false
        },

        isCurrentUser(item) {
            if (this.CURRENT_USER) {
                return this.CURRENT_USER.id === item.id
            } else {
                return false
            }
        },

        getEstadoDescription(item) {
            if (this.isSuperadmin(item)) {
                return "superadmin"
            } else return item.status_description
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "grey lighten-1"
                case "4":
                    return "red lighten-1"
                default:
                    return "black"
            }
        },

        getChipColor(item) {
            if (this.isSuperadmin(item)) {
                return "black"
            }

            switch (item.status) {
                case 0:
                    return "red lighten-1"
                case 9:
                    return "grey lighten-1"
                case 10:
                    return "success lighten-1"
            }
        }
    },

    computed: {
        ...mapGetters(["USERS", "CURRENT_USER"]),

        pagination: {
            get: function() {
                return this.$store.getters.USERS_PAG
            },
            set: function(value) {
                this.$store.commit("SET_USERS_PAG", value)
            }
        },
        searchTerm() {
            return this.filter.search
        }
    },

    watch: {
        pagination: {
            handler() {
                if (this.estado && !this.estadoApplied) {
                    //si se envio el valor estado por las props y no se ha aplicado, se aplica una sola vez
                    this.usuarioEstado = this.estado
                    this.estadoApplied = true
                }
                this.loadData(this.usuarioEstado)
            },
            deep: true
        },

        searchTerm() {
            this.searchData()
        }
    }
}
</script>
